import { observer } from "mobx-react"
import { Col, Form, FormInstance, Input, Row, Select } from "antd"
import { DefaultOptionType } from "antd/es/select"

import { WhiteListCreateReq } from "@src/pages/settingsWhitelist/classes/WhiteList"
import { SubmitButton } from "@src/shared/componemts/SubmitButton"

export type Props = {
  currencies: DefaultOptionType[]
  currenciesIsLoading: boolean
  form: FormInstance
  isLoading: boolean
  submit: (req: WhiteListCreateReq) => void
}
export const WhiteListForm = observer(
  ({ currencies, currenciesIsLoading, form, isLoading, submit }: Props) => {
    return (
      <Form
        form={form}
        id="GENERATED_ID_WHITELISTFORM_FORM_VOID_1"
        layout="vertical"
        name="whitelist"
        onFinish={submit}
        size="large"
      >
        <Row align="top" gutter={16}>
          <Col span={10}>
            <Form.Item
              id="GENERATED_ID_WHITELISTFORM_TSX_FORM.ITEM_VOID_1"
              label="Address"
              name="address"
              rules={[
                { message: "Please input network address", required: true },
              ]}
            >
              <Input placeholder="Enter network address" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              id="GENERATED_ID_WHITELISTFORM_TSX_FORM.ITEM_VOID_2"
              label="Name"
              name="name"
              rules={[{ message: "Please input address name", required: true }]}
            >
              <Input placeholder="Enter address name" />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item
              id="GENERATED_ID_WHITELISTFORM_TSX_FORM.ITEM_VOID_3"
              label="Network"
              name="network"
              rules={[
                { message: "Please select at least one", required: true },
              ]}
            >
              <Select
                loading={isLoading || currenciesIsLoading}
                options={currencies}
                placeholder="Select network"
              />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item
              id="GENERATED_ID_WHITELISTFORM_TSX_FORM.ITEM_VOID_4"
              label={" "}
            >
              <SubmitButton
                buttonProps={{
                  loading: isLoading,
                  size: "large",
                  type: "primary",
                }}
                form={form}
              >
                Save Address
              </SubmitButton>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    )
  },
)
